import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskProjectDashboardsListRoute: InvariantJiraRoute = {
	name: 'servicedesk-avp-project-dashboards-list',
	path: '/jira/servicedesk/projects/:projectKey/dashboards',
};
